import React from "react";
import { Card } from "components/ui/BootstrapCompat";
import { WITHDRAW_FEE_AMOUNT } from "../withdraw.types";
import { formatCurrency } from "../withdraw.utils";

type Props = {
  show: boolean;
  availableAmount: number;
  currencyLabel: string;
  kycStatus: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
};

export default function WithdrawRequirementsAlert(props: Props) {
  const {
    show,
    availableAmount,
    currencyLabel,
    kycStatus,
    bankName,
    accountName,
    accountNumber,
  } = props;

  if (!show) return null;

  return (
    <Card className="mb-3 border-red-200 bg-red-50 text-red-700">
      <Card.Body>
        <p className="mb-2 font-semibold">ເງື່ອນໄຂທີ່ຕ້ອງຜ່ານກ່ອນຖອນ:</p>
        <ul className="list-disc space-y-1 pl-5 text-sm">
          {availableAmount <= 0 && <li>ຍອດຖອນຕ້ອງຫຼາຍກວ່າ 0 {currencyLabel}</li>}
          {availableAmount > 0 && availableAmount <= WITHDRAW_FEE_AMOUNT && (
            <li>
              ຍອດຄົງເຫຼືອຕ້ອງຫຼາຍກວ່າຄ່າທຳນຽມ{" "}
              {formatCurrency(WITHDRAW_FEE_AMOUNT)} {currencyLabel}
            </li>
          )}
          {kycStatus !== "approved" && <li>ຕ້ອງຜ່ານການອະນຸມັດ KYC</li>}
          {(!bankName || !accountName || !accountNumber) && (
            <li>ຕ້ອງມີຂໍ້ມູນບັນຊີທະນາຄານຈາກ KYC ໃຫ້ຄົບ</li>
          )}
          <li>ລະບົບນີ້ຖອນແບບທັງຍອດເທົ່ານັ້ນ</li>
        </ul>
      </Card.Body>
    </Card>
  );
}
